<app-module-header
  [title]="organization.organizationName + ' - ' + ('PARKING_FINES.TITLE' | transloco)"
  icon="money"
></app-module-header>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="fines-body">
  <div class="search-container">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label> {{ 'PARKING_FINES.SEARCH_LABEL' | transloco }}</mat-label>
      <input matInput
        [(ngModel)]="searchTerm"
        (keyup)="applyFilter()"
        [placeholder]="'PARKING_FINES.SEARCH_PLACEHOLDER' | transloco">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <div class="fines-container">
    @for (session of filteredSessions; track session) {
      <div class="fine-card">
        <div class="fine-card-header">
          <div class="license-plate">
            <mat-icon>directions_car</mat-icon>
            <span class="plate-number">{{ session.licensePlate || 'UNKNOWN' }}</span>
          </div>
          <span class="status-badge" [ngClass]="{'active': !session.outTime, 'completed': session.outTime}">
            {{ session.outTime ? 'Completed' : 'Active' }}
          </span>
        </div>
        <div class="fine-details">
          <div class="detail-row">
            <mat-icon>location_on</mat-icon>
            <span>{{ session.parkingName || 'N/A' }}</span>
          </div>
          <div class="detail-row">
            <mat-icon>schedule</mat-icon>
            <span>In: {{ session.inTime | date:'medium' }}</span>
          </div>
          @if (session.outTime) {
            <div class="detail-row">
              <mat-icon>schedule</mat-icon>
              <span>Out: {{ session.outTime | date:'medium' }}</span>
            </div>
          }
        </div>
        @if (session.images?.length) {
          <div class="images-container">
            <h4>Evidence Images</h4>
            <div class="image-gallery">
              @for (image of session.images; track image) {
                <div class="image-thumbnail">
                  <img [src]="'data:image/jpeg;base64,' + image.data" alt="Vehicle image" (click)="openImageDialog(image.data)">
                  <!-- <div class="image-meta">
                  <small>{{ image.cam }}</small>
                  <small>{{ image.created | date:'short' }}</small>
                </div> -->
              </div>
            }
          </div>
        </div>
      }
      <!-- <div class="actions" *ngIf="!session.outTime">
      <button mat-stroked-button color="primary">
        <mat-icon>receipt</mat-icon> Issue Fine
      </button>
      <button mat-stroked-button color="warn" (click)="dismissAlert(session.id)">
        <mat-icon>close</mat-icon> Dismiss
      </button>
    </div> -->
  </div>
}
</div>

@if (!parkingSessions || parkingSessions.length === 0) {
  <div class="no-fines">
    <mat-icon>warning</mat-icon>
    <p>{{ 'PARKING_FINES.NO_FINES' | transloco }}</p>
  </div>
}
</div>
